import styled from '@emotion/styled'

export const CustomButton = styled.button(
  ({ theme }) => `
    position: absolute;
    right: ${theme.ds.Space3X};
    display: flex;
    background-color: transparent;
    cursor: pointer;

    @media (max-width: 768px) {
      right: ${theme.ds.Space2X};
    }

    > svg > g {
      stroke: ${theme.ds.ColorBaseGreyLevel3};
    }

    @media (max-width: 420px) {
      transform: scale(0.75);
    }
  `
)
